import Home from './Home.page';

export default Home;
